import { injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "by/gamefactory/scene/SceneManager";
import { NotificationLayer } from "by/gamefactory/scene/layer/NotificationLayer";

@injectable()
export class NotificationLayerProvider {
    public readonly notificationLayer: NotificationLayer;

    public constructor(sceneManager: SceneManager) {
        this.notificationLayer = sceneManager.notificationsLayer;    
    }
}